<script lang="ts" setup>
interface Props{
  label: string;
  checked: boolean;
}

const props = defineProps<Props>();

const icon = computed(() => {
  return props.checked ? 'fa-circle-check' : 'fa-circle-xmark';
});

const color = computed(() => {
  return props.checked ? 'success' : 'danger';
});
</script>

<template>
  <IconText
    :label="label"
    :icon="icon"
    :color="color"
  />
</template>

<style scoped>

</style>
